import styled from "styled-components";

export const MobileSideNavWrapper = styled.section`
    /* width: 280px; */
    height: 100dvh;
    background: #000;
    overflow: hidden;
    margin-left: auto;
    max-width: 0px;
    -webkit-animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;
    /* for less modern browsers */
    animation: slide-in-out 0.6s cubic-bezier(0.455, 0.03, 0, 1) forwards;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    padding: 24px;

    @-webkit-keyframes slide-in-out {
        from {
            max-width: 70px;
            opacity: 0;
        }

        to {
            max-width: 280px;
            opacity: 1;
        }
    }

    @keyframes slide-in-out {
        from {
            max-width: 70px;
            opacity: 0;
        }

        to {
            max-width: 280px;
            opacity: 1;
        }
    }

    .mobile-nav__top-section {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        .mobile-nav__top-section-left {
            display: flex;
            align-items: center;
            h5 {
                color: #fff;
                font-size: 0.8125rem;
                font-weight: 700;
                line-height: 16px;
                width: 136px;
            }
        }
    }
    nav {
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        flex: 1;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 2px;
            border: 1px solid transparent;
        }
    }
    .auth-layout__side-nav__navs-wrap-disabled {
        opacity: 0.4;
        pointer-events: none;
    }
`;

export const BusinessProfileCircle = styled.div`
    width: 32px;
    height: 32px;
    padding: 2px;
    margin-right: 8px;
    background: #fff;
    border-radius: 50%;

    .mobile-nav__bus-profile-inner-circle {
        border: 1px solid #000;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: top;
    }
    p {
        color: #000;
        font-size: 15px;
        font-weight: 400;
        line-height: 16px;
    }
`;

export const NavItemsCardStyled = styled.div`
    width: 100%;

    .mobile-nav__items-with-children {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &:not(:first-child) {
        margin-top: 24px;
    }

    .mobile-nav__items-left {
        display: flex;
        align-items: center;
    }
    p {
        color: #cacaca;
        font-size: 0.75rem;
        font-weight: 700;
        line-height: normal;
        margin-left: 8px;
    }
    .mobile-nav__items-active {
        p {
            font-weight: 700;
            color: #fff;
        }
    }
`;

export const NavItemLinksWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    p {
        color: #cacaca;
        font-size: 0.75rem;
        font-weight: 600;
        line-height: 16px;
        margin-left: 32px;
        padding-top: 16px;
    }
    .mobile-nav__children-active-link {
        p {
            font-weight: 700;
            color: #fff;
        }
    }
`;

export const MobileBottomSection = styled.section`
    margin-top: 24px;
    .mobile-nav__bottom-extra-style {
        align-items: flex-start !important;
    }

    .mobile-nav__bottom-section-wrap {
        padding: 16px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        :first-child {
            padding: 14px 0px;
        }

        .mobile-nav__bottom-profile-left {
            display: flex;
            align-items: center;
            h5 {
                color: #fff;
                font-size: 0.75rem;
                font-weight: 800;
                line-height: normal;
                margin-bottom: 2px;
            }
            p {
                color: #dbdce0;
                font-size: 0.75rem;
                font-weight: 400;
                line-height: normal;
            }
            .mobile-nav__bottom-profile {
                width: 36px;
                height: 36px;
                background-size: cover;
                border-radius: 50%;
                background-position: top;
                background-color: #e8e8e8;
                display: flex;
                align-items: center;
                justify-content: center;
                p {
                    color: #000;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 16px;
                }
            }
            .mobile-nav__bottom-profile-mid {
                margin-left: 8px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }
        }
    }
    .mobile-nav__bottom-section-logout {
        display: flex;
        padding-top: 24px;
        cursor: pointer;
        align-items: center;
        p {
            color: #f7685b;
            font-size: 0.75rem;
            font-weight: 800;
            line-height: normal;
            margin-left: 4px;
        }
    }
`;

export const Divider = styled.div`
    border-top: 1px solid rgb(150, 150, 150, 0.5);
    margin: 0px -24px;
    display: flex;
    justify-content: center;
`;
